import { CapabilitySet, KnownCapability, ScopeLevel } from "@/types/capability.types";

import { hasAnyCapability } from "./hasCapability";

/**
 * Finance-read keys accepted per context level: the level's own finance key
 * plus its strict ancestors' keys. The backend resolver's ancestor walk
 * contributes each ancestor node's exact keys into a descendant's capability
 * set, so a platform-level `PLATFORM_FINANCE:READ` grant appears verbatim in
 * org/league sets — the FE only needs to accept it, not re-derive the
 * hierarchy (same justification as `AUDIT_READ_KEYS`).
 */
export const FINANCE_READ_KEYS = {
  platform: ["PLATFORM_FINANCE:READ"],
  organization: ["ORG_FINANCE:READ", "PLATFORM_FINANCE:READ"],
  league: ["LEAGUE_FINANCE:READ", "ORG_FINANCE:READ", "PLATFORM_FINANCE:READ"],
} as const satisfies Record<ScopeLevel, readonly KnownCapability[]>;

/**
 * Whether the set grants finance/transactions read at the given context level
 * (own key or an ancestor level's key).
 */
export const hasFinanceRead = (set: CapabilitySet | null | undefined, level: ScopeLevel): boolean =>
  hasAnyCapability(set, FINANCE_READ_KEYS[level]);
